<template>
  <li @click.stop="toggleFloded">
    <h5 v-if="!Array.isArray(items)" ><i class="el-icon-caret-right" v-bind:class="{ rotatecaret: !floded}"></i>{{index}}</h5>
    <h5 v-if="Array.isArray(items)" @click.stop="toggleItem"><i class="el-icon-caret-right" v-bind:class="{ rotatecaret: !itemFloded}"></i>{{index}}</h5>

    <ul v-if="Array.isArray(items)" v-show="!itemFloded">
      <li v-for="(item, index) in items" :key="index"><el-checkbox v-model="checkedList[item]" v-on:change="$emit('list-update', checkedList)">{{item}}</el-checkbox></li>
    </ul>
    <ul>
      <itemTree v-on:list-update="listUpdate" v-for="(item, index) in items" :key="index" :items="item" :index="index" :checkedList="checkedList" v-if="!Array.isArray(items)" class="item-unit" v-show="!floded"/>
    </ul>
  </li>
</template>

<script>
import itemTree from './itemTree'
export default {
  name: 'itemTree',
  components: {
    itemTree
  },
  props: [
    'items',
    'index',
    'checkedList'
  ],
  data () {
    return {
      floded: true,
      itemFloded: true
      // checkedList: {}
    }
  },
  methods: {
    listUpdate: function (event) {
      this.checkedList = Object.assign(this.checkedList, event)
      this.$emit('list-update', this.checkedList)
    },
    toggleFloded: function () {
      this.floded = !this.floded
    },
    toggleItem: function () {
      this.itemFloded = !this.itemFloded
    }
  }
}
</script>

<style lang="scss" scoped>
.floded {
  display: none;
}

ul{
  list-style-type: none;
  padding-left: 10px;
}

li {
  .rotatecaret {
    transform: rotate(90deg);
  }
  h5 {
    font-size: 14px;
    font-weight: 400;
    margin: 0;
    padding: 5px 0;
    color: #606266;
  }
}
</style>
